// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Card,
  CardMedia,
  CardHeader,
  Divider,
  CardContent,
  Box,
  Typography,
  CircularProgress,
  Link,
  Button,
  CardActions
} from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Adjust based on your routing setup
import ExamIcon from "../../assets/img/card-img-1.svg";
import { CERT_APP_REDIRECT_URL } from "../../config/constant";

const ExamCard = ({
  auth = { isAuthenticated: false },
  landingStats = { backgroundProcess: false, response: { totalActiveExams: 0 } },
  contactDetails = { examinationGuidelinesUrl: '', signUpForExamUrl: '' },
  routes = { exams: '/' },
  authContext = { appSignIn: () => {} },
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Card sx={{ 
        p: 3, 
        mb: 3, 
        minHeight: 450,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        <CardMedia component="img" sx={{ width: 100, ml: 2 }} image={ExamIcon} />
        <CardHeader
          title="Exams"
          subheader=""
          titleTypographyProps={{
            align: 'left',
          }}
          subheaderTypographyProps={{
            align: 'left',
          }}
        />
        <Divider variant="middle" />
        <CardContent>
          <Box
            sx={{
              mb: 2,
              height: 124
            }}
          >
          {auth.isAuthenticated ? (
              <>
                {landingStats.backgroundProcess ? (
                  <CircularProgress size={30} sx={{ color: 'grey.500' }} />
                ) : (
                  <Typography
                    component="h2"
                    variant="h3"
                    color="text.primary"
                  >
                    {landingStats.response.totalActiveExams}
                  </Typography>
                )}

                <Typography color="text.secondary">Active Exams</Typography>
              </>
            ) : (
              <Box>
                <Typography align="left" sx={{ mt: 4, mb: 2, minHeight: 32, display: 'flex', alignItems: 'center' }}>
                  <Link
                    color="inherit"
                    href={contactDetails.examinationGuidelinesUrl}
                    underline="none"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: 'text.primary', fontWeight: 400, fontSize: '1rem' }}
                  >
                    Examination Guidelines
                  </Link>
                </Typography>
                <Link
                  color="inherit"
                  href={contactDetails.signUpForExamUrl}
                  underline="none"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: 'text.primary', display: 'block', fontWeight: 400, fontSize: '1rem' }}
                >
                  Sign up for an exam
                </Link>
              </Box>
            )}
          </Box>
        </CardContent>
        <CardActions>
          {auth.isAuthenticated ? (
            <Button
              onClick={() => {
                navigate(routes.exams);
              }}
              variant="contained"
              sx={{ width: { xs: '80%', md: '100%' } }}
            >
              View All
            </Button>
          ) : (
            <Button
              onClick={() => {
                localStorage.setItem(CERT_APP_REDIRECT_URL, routes.exams);
                authContext.appSignIn();
              }}
              variant="contained"
              sx={{ width: { xs: '80%', md: '100%' } }}
            >
              Get Certified
            </Button>
          )}
        </CardActions>
      </Card>
    </>
  );
};

export default ExamCard;
